import React from 'react'
import { useState } from 'react';
import { Link } from 'react-router-dom'
import { FiPhone, FiSearch } from 'react-icons/fi'
import { FiFileText } from "react-icons/fi";
import PropTypes from 'prop-types';
import Ctaicon from './ctaicon';
import sanitizeHtml from 'sanitize-html';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchResults } from '../slices/searchSlice';
import Paquetesmini from './paquetesmini';
import useCsrfToken from '../hooks/useCsrfToken';
import { LuScanEye } from 'react-icons/lu';

const EXTERNAL_URL = process.env.REACT_APP_EXTERNAL_SOURCE;

ServiceSidebars.propTypes = {
    brochure_url: PropTypes.string,
    cta_url: PropTypes.string,
    phone_1: PropTypes.string,
    title: PropTypes.string,
    listing_type: PropTypes.string,
    cta_icon: PropTypes.string,
    listingid: PropTypes.string,
    vrurl: PropTypes.string,
};

export default function ServiceSidebars({ brochure_url = '', cta_url = '', phone_1 = '', title = '', listing_type = '', cta_icon = '', listingid = '', vrurl = '' }) {
    const { csrfToken } = useCsrfToken();
    const dispatch = useDispatch();
    const reflistingid = useSelector((state) => state.contact.listingid);

    const Initresults = (data) => {
        // console.log('data', data);
        dispatch(setSearchResults(data));
        window.location.href = '/servicios-busqueda';
    }
    const [noResultsAlert, setNoResultsAlert] = useState(false);
    const [loadingSearch, setLoadingSearch] = useState(false);

    const API_URL = process.env.REACT_APP_API_URL;
    const sanitizeTerm = (html) => {
        return sanitizeHtml(html);
    };
    function handleSearchSubmit(event) {
        event.preventDefault();
        setLoadingSearch(true);
        setNoResultsAlert(false);
        setTimeout(() => {
            console.log('wait time...');
            const searchTerm = event.target.elements.searchItem.value;
            // const csrf = event.target.elements._token.value;
            const searchUrl = `${API_URL}/api/search-listings`;

            if (searchTerm.trim() === '') {
                setNoResultsAlert(true);
                setLoadingSearch(false);
                return;
            }
            if (searchTerm.trim().length >= '4') {
                fetch(searchUrl, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify({ search: sanitizeTerm(searchTerm) }),
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data?.length > 0) {
                            setNoResultsAlert(false);
                            setLoadingSearch(false);
                            Initresults(data);
                        } else {
                            setNoResultsAlert(true);
                            setLoadingSearch(false);
                        }
                    })
                    .catch(error => {
                        console.error('Error during search:', error);
                    });
            }
        }, 500);
    }

    return (
        <>
            <div className="card bg-white p-4 rounded shadow sticky-bar">
                <div>
                    {cta_url && (
                        <div className='text-center'>
                            <Ctaicon iconName={cta_icon} destination={cta_url} reflistingid={reflistingid ? reflistingid : listingid} />
                        </div>
                    )}
                    {phone_1 && (
                        <div className='text-center'>
                            <Link to={`tel:${phone_1}`} className="btn btn-secondary w-100 btn-sm mb-2 mx-auto text-center">
                                <FiPhone fontSize={'2em'} />
                                <span> Solicitar Información</span>
                            </Link>
                        </div>
                    )}
                    {brochure_url && (
                        <div className='text-center'>
                            <Link to={`${EXTERNAL_URL}${brochure_url}`} className="btn btn-primary w-100 btn-sm mb-2 mx-auto text-center" target="_blank" rel="noreferrer">
                                <FiFileText fontSize={'2em'} />
                                <span> Descargar Folleto</span>
                            </Link>
                        </div>
                    )}
                    {vrurl && (
                        <div className='text-center'>
                            <Link to={vrurl} className="btn btn-light w-100 btn-sm mb-2 mx-auto text-center" target="_blank" rel="noreferrer">
                                <LuScanEye fontSize={'2em'} />
                                <span> Recorrido Virtual</span>
                            </Link>
                        </div>
                    )}
                    <br />
                    <h6 className="pt-2 pb-2 bg-light rounded text-center">Buscar servicios</h6>

                    <div className="search-bar mt-4">
                        <div id="itemSearch" className="menu-search mb-0">
                            <form role="search" method="get" id="searchItemform" className="searchform" onSubmit={handleSearchSubmit}>
                                <input type="hidden" name="_token" id="_token" value={csrfToken} />
                                <input type="text" className="form-control rounded border" name="searchItem" id="searchItem" placeholder="Buscar..." />
                                <FiSearch className="icons" />
                                <input type="submit" id="searchItemsubmitd" value="Buscar" className="btn btn-block btn-success btn-sm w-100 mt-2" />
                            </form>
                            {loadingSearch && (
                                <div className="spinner-border text-success mx-auto my-2 text-center" role="status">
                                    <span className="visually-hidden text-center">Loading...</span>
                                </div>
                            )}
                            {noResultsAlert && (
                                <>
                                    <br />
                                    <div className="alert alert-warning alert-dismissible fade show" role="alert">
                                        <strong>No se encontraron resultados</strong> intente con otro término de búsqueda.
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <Paquetesmini listingid={listingid} />

                {/* <div className="mt-4 pt-2 text-center">
                    <h6 className="pt-2 pb-2 bg-light rounded">Etiquetas</h6>
                    <ul className="tagcloud list-unstyled mt-4">
                            {tagCloud.map((item,index)=>{
                                    return(
                                            <li className="d-inline-flex m-1" key={index}><Link to="#" className="rounded fw-medium text-dark py-1 px-2">{item}</Link></li>
                                    )
                            })}
                    </ul>
            </div> */}
            </div>
        </>
    )
}
